/**
 * 剧本监测 · 素材库共享类型与标签
 */

export const DISPATCH_SCRIPT_MATERIAL_TYPES = ["sticker", "image", "video"] as const;
export type DispatchScriptMaterialType = (typeof DISPATCH_SCRIPT_MATERIAL_TYPES)[number];

export const DISPATCH_SCRIPT_MATERIAL_TYPE_LABELS: Record<DispatchScriptMaterialType, string> = {
  sticker: "表情",
  image: "图片",
  video: "视频",
};

export const DISPATCH_SCRIPT_MATERIAL_DHASH_STATUSES = [
  "none",
  "ready",
  "failed",
  "skipped",
] as const;
export type DispatchScriptMaterialDHashStatus =
  (typeof DISPATCH_SCRIPT_MATERIAL_DHASH_STATUSES)[number];

export const DISPATCH_SCRIPT_MATERIAL_SOURCES = ["upload", "archive"] as const;
export type DispatchScriptMaterialSource = (typeof DISPATCH_SCRIPT_MATERIAL_SOURCES)[number];

export const DISPATCH_SCRIPT_MATERIAL_IMAGE_MIME_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
]);

export const DISPATCH_SCRIPT_MATERIAL_VIDEO_MIME_TYPES = new Set([
  "video/mp4",
  "video/quicktime",
  "video/webm",
  "video/x-msvideo",
]);

export function isDispatchScriptMaterialType(
  value: string
): value is DispatchScriptMaterialType {
  return (DISPATCH_SCRIPT_MATERIAL_TYPES as readonly string[]).includes(value);
}
